import { render } from "./wfm-dow-type.vue?vue&type=template&id=22d02dc0&scoped=true"
import script from "./wfm-dow-type.vue?vue&type=script&lang=js"
export * from "./wfm-dow-type.vue?vue&type=script&lang=js"

import "./wfm-dow-type.vue?vue&type=style&index=0&id=22d02dc0&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-22d02dc0"]])

export default __exports__